import { getContext, setContext } from "svelte"

const CONTEXT = Symbol('META')

export function createMetaContext(): MetaContext {
      return setContext(CONTEXT, new MetaContext())
}

export function getMetaContext(): MetaContext {
      return getContext(CONTEXT)
}

type MetaObject = {
  title?: string|undefined
  imageUrl?: string|undefined
  imageAlt?: string|undefined
  description?: string|undefined
}


class MetaContext {
  title: string|undefined = $state(undefined)
  imageUrl: string|undefined = $state(undefined)
  imageAlt: string|undefined = $state(undefined)
  description: string|undefined = $state(undefined)


  constructor() {}

  setMeta(meta: MetaObject) {
    this.resetMeta()
    this.title = meta.title ?? undefined
    this.imageUrl = meta.imageUrl ?? undefined
    this.imageAlt = meta.imageUrl ?? undefined
    this.description = meta.description ?? undefined
    return this
  }

  resetMeta() {
    this.title = undefined
    this.imageUrl = undefined
    this.imageAlt = undefined
    this.description =  undefined
    return this
  }

}